import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { translate, showMessageToastCustom, isNullOrEmpty } from '../../../../utils/util';
import { Input, Breadcrumbs, ConfirmButtons } from '../../../../components/UI/ComponentsUI';
import ContainerService from '../../../../services/ContainerService';
import { validateInputsRequired, onValueChange } from '../../../../utils/handleChangeHooks';
import { getVision } from '../../../../services/auth';
import { ENUMS, VISIONS } from '../../../../utils/constants';
import SelectMaritimeCompany from '../../../../components/UI/SelectMaritimeCompany';
import SelectHarbor from '../../../../components/UI/SelectHarbor';
import SelectNew from '../../../../components/UI/SelectNew';

const FreeTimeInsert = (props) => {
    const update = props.location?.state?.update;
    const [data, setData] = useState(props.location?.state?.update && props.freetime ? props.freetime : {});

    useEffect(() => {
        if (!props.containerTypes) props.getContainerTypes();

        if (!props.containerSizes) {
            props.getContainerSizes({ internal: false });
        }
        // eslint-disable-next-line
    }, []);


    const onChange = (event) => {
        onValueChange(event, data, setData);
    };

    const onChangeMaritimeCompany = (event) => {
        data.maritimeCompanyId = event.id;
        data.flucomexCode = event.flucomexCode
        data.ecomexCode = event.ecomexCode
        setData({ ...data });
    };

    const onChangeHarborOrig = (event) => {
        data.harborOrigId = event.id;
        setData({ ...data });
    };

    const onChangeHarborOrigin = (event) => {
        data.harborOriginId = event.id;
        data.countryCode = event.countryCode
        setData({ ...data });
    };


    const onChangeHarborDestination = (event) => {
        data.harborDestinationId = event.id;
        setData({ ...data });
    };

    const redirect = () => {
        props.history.replace('./list');
    }

    const validations = () => {
        let validation = true;
        if (isNullOrEmpty(data.maritimeCompanyId)) {
            validation = false;
            showMessageToastCustom(translate('warning', 'general'), 'Companhia maritima não selecionada.', 3000, 'mdi mdi-alert-circle-outline red-text');
        }
        if (isNullOrEmpty(data.harborOriginId)) {
            validation = false;
            showMessageToastCustom(translate('warning', 'general'), 'Porto Origem não selecionado.', 3000, 'mdi mdi-alert-circle-outline red-text');
        }

        if (isNullOrEmpty(data.harborDestinationId)) {
            validation = false;
            showMessageToastCustom(translate('warning', 'general'), 'Porto Destino não selecionado.', 3000, 'mdi mdi-alert-circle-outline red-text');
        }

        if (isNullOrEmpty(data.containerTypeId)) {
            validation = false;
            showMessageToastCustom(translate('warning', 'general'), 'Tipo de Container não selecionado.', 3000, 'mdi mdi-alert-circle-outline red-text');
        }

        if (isNullOrEmpty(data.containerSizeId)) {
            validation = false;
            showMessageToastCustom(translate('warning', 'general'), 'Tamanho de Container não selecionado.', 3000, 'mdi mdi-alert-circle-outline red-text');
        }

        return validation;
    }

    const onConfirm = () => {
        if (validateInputsRequired("freetimeInsert") && validations()) {
            if (update) {
                props.update(data, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-update', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        redirect();
                    }
                });
            } else {
                props.insert(data, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-include', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        redirect();
                    }
                });
            }
        }

    };

    const subtitlesPlant = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { icon: "mdi mdi-domain", label: "FreeTime" }];
        subtitlesItems = [...subtitlesItems, { label: update ? translate('menu.update', 'container') : translate('menu.insert', 'container') }];
        return subtitlesItems;
    }

    return (
        <div>
            <Breadcrumbs id="freetimeInsert" title={{ icon: "mdi mdi-clipboard-check-outline", label: "FreeTime" }}
                subtitles={subtitlesPlant()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <form id="maritimeInsert">
                                <div className="row" style={{ marginBottom: '0px' }}>
                                    <div className="input-field no-padding col s5">
                                        <SelectMaritimeCompany
                                            required
                                            name="maritimeCompany"
                                            id="maritimeCompany"
                                            focus="true"
                                            defaultValue={data?.maritimeCompanyId}
                                            value={data.maritimeCompanyId || ""}
                                            onChange={(evt) => onChangeMaritimeCompany(evt)}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s3">
                                        <Input
                                            required={getVision() === VISIONS.PortoReal || getVision() === VISIONS.Palomar}
                                            label="Código Flucomex"
                                            id="flucomexCode"
                                            name="flucomexCode"
                                            maxLength={3}
                                            type="number"
                                            onChange={onChange}
                                            value={data?.flucomexCode || ''} />
                                    </div>
                                    <div className="input-field no-padding col s3">
                                        <Input
                                            required
                                            label="Código Ecomex"
                                            id="ecomexCode"
                                            name="ecomexCode"
                                            maxLength={3}
                                            type="number"
                                            onChange={onChange}
                                            value={data?.ecomexCode || ''} />
                                    </div>
                                    <div className="input-field no-padding col s4">
                                        <SelectHarbor
                                            required
                                            label={"Porto Origem"}
                                            name="harborOriginId"
                                            id="harborOriginId"
                                            focus="true"
                                            defaultValue={data?.harborOriginId}
                                            value={data.harborOriginId || ""}
                                            onChange={(evt) => onChangeHarborOrigin(evt)}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s4">
                                        <SelectHarbor
                                            required
                                            label={"Porto Destino"}
                                            name="harborDestinantionId"
                                            id="harborDestinantionId"
                                            focus="true"
                                            defaultValue={data?.harborDestinationId}
                                            value={data.harborDestinationId || ""}
                                            onChange={(evt) => onChangeHarborDestination(evt)}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s3">
                                        <Input
                                            required
                                            label="Código País"
                                            id="countryCode"
                                            name="countryCode"
                                            maxLength={2}
                                            type="text"
                                            onChange={onChange}
                                            value={data?.countryCode || ''} />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <SelectNew
                                            required
                                            id="containerTypeId"
                                            name="containerTypeId"
                                            placeHolder={translate('choose-one-option', 'general')}
                                            label={translate('fields.type', 'container')}
                                            data={props.containerTypes?.map((x) => ({ id: x.id, text: x.containerTypeName }))}
                                            change={onChange}
                                            value={data?.containerTypeId || ""}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s4">
                                        <SelectNew
                                            id="containerSizeId"
                                            required
                                            name="containerSizeId"
                                            value={data?.containerSizeId || ''}
                                            change={onChange}
                                            placeHolder={translate('choose-one-option', 'general')}
                                            label={translate('fields.size', 'container')}
                                            data={props.containerSizes?.map((x) => ({ id: x.id, text: x.containerSizeName }))}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s4">
                                        <Input
                                            required
                                            label="Dias Venc."
                                            id="dueDays"
                                            name="dueDays"
                                            maxLength={2}
                                            type="number"
                                            onChange={onChange}
                                            value={data?.dueDays || ''} />
                                    </div>
                                    <div className="input-field no-padding col s3">
                                        <Input
                                            required
                                            label="Multa Diária"
                                            id="dailyFine"
                                            name="dailyFine"
                                            maxLength={9}
                                            type="number"
                                            onChange={onChange}
                                            value={data?.dailyFine || ''} />
                                    </div>
                                    <div className="input-field no-padding  col s3">
                                        <Input
                                            required
                                            label="Moeda"
                                            id="currency"
                                            name="currency"
                                            maxLength={3}
                                            type="text"
                                            onChange={onChange}
                                            value={data?.currency || ''} />
                                    </div>
                                </div>
                            </form>
                            <ConfirmButtons
                                onConfirm={() => onConfirm()}
                                onCancel={() => props.history.go(-1)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        freetime: state.containerReducer.freetime,
        containerTypes: state.containerReducer.containerTypes,
        containerSizes: state.containerReducer.containerSizes
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        insert: (data, callback) => {
            dispatch(ContainerService.insertFreeTime(data, callback));
        },
        update: (data, callback) => {
            dispatch(ContainerService.updateFreeTime(data, callback));
        },
        getContainerTypes: () => {
            dispatch(ContainerService.getContainerTypes(null));
        },
        getContainerSizes: (filter) => {
            dispatch(ContainerService.getContainerSizes(filter));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FreeTimeInsert)));
